import { Trans } from '@lingui/react'
import { Alert, Link } from '@mui/material'

type PromotionQtyAlertProps = {
  max: number
  remaining?: number
  qty: number
}

export const PromotionQtyAlert = (props: PromotionQtyAlertProps) => {
  const { max, remaining, qty = 1 } = props
  const hasReachedLimit = remaining === 0
  const hasReachedMax = qty >= max
  const hasReachedRemaining = remaining && qty >= remaining
  const showMessage = hasReachedLimit || hasReachedMax || hasReachedRemaining

  if (!showMessage) return null

  return (
    <Alert
      severity='error'
      sx={(theme) => ({
        gridArea: 'message',
        mb: theme.spacings.xxs,
        borderRadius: theme.shape.borderRadius / 2,
        '& .MuiAlert-message': {
          py: '6px',
        },
      })}
    >
      {hasReachedLimit && (
        <>
          <Trans id='You already have 10 of these products in your shopping cart.' />{' '}
        </>
      )}
      <Trans id='For this offer, a maximum of {max} items per product applies.' values={{ max }} />
    </Alert>
  )
}
